// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"86265410","233":"7f2098a0","240":"86265410","858":"86265410","871":"f41be594","989":"ff220211"}[chunkId] + ".chunk.css";
};